import { z } from "zod";

export const worldCitiesSchema = z.object({
	type: z.string(),
	features: z.array(
		z.object({
			type: z.string(),
			geometry: z.object({
				type: z.string(),
				coordinates: z.array(z.coerce.string()),
			}),
			properties: z.object({
				en_label: z.string(),
				ar_label: z.string(),
				id_area: z.number(),
			}),
		}),
	),
});

export type IWorldCities = z.infer<typeof worldCitiesSchema>;
export type IWorldCitiesFeatures = z.infer<
	typeof worldCitiesSchema
>["features"];
